const DIRECTIONS_BASE_URL = `https://www.google.com/maps/search/?api=1`;

export const getGoogleMapsSearchLink = (location: string) => {
  const url = new URL(DIRECTIONS_BASE_URL);
  url.searchParams.set('query', location);
  return url.toString();
};
